module.exports = __webpack_public_path__ + "static/media/map-transparant.3a1ef11c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/map-transparant.png
// module id = 2283
// module chunks = 0